import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import APIURL from "../../common/Config";
import defaultProfileImage from "../../assets/profilechat.webp";
import { useDispatch } from "react-redux";
import { openAuthModal } from "../../redux/authSlice";
import toast from "react-hot-toast";
import "./AstrologerSlider.css";

const AstrologerSlider = () => {
  const [astrologers, setAstrologers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cid = localStorage.getItem("customerId") || "0";
        const res = await axios.get(
          `${APIURL}/astroservice/list/astrologer/loggedin?customerId=${cid}`
        );
      const active = res.data
  .filter((a) => a.status === 1 && a.chatStatus === 2) 
  .map((a) => ({
            image: a.photoUrlpath || defaultProfileImage,
            name: a.firstName,
            details: `${a.specialization || ""} | ${a.language || ""}`,
            rate: a.chatCharges,
            astrologerId: a.astrologerId,
            chatStatus: a.chatStatus,
          }));
        setAstrologers(active);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChat = async (a) => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const phone = localStorage.getItem("phoneNumber");
    if (!isLoggedIn || !phone) {
      toast.error("Please login to continue.");
      dispatch(openAuthModal("login"));
      return;
    }
    if (a.chatStatus !== 2) {
      toast.error("Astrologer is currently offline.");
      return;
    }
    localStorage.setItem("astrologerName", a.name);
    localStorage.setItem("astrologerImage", a.image);
    navigate(`/inquary/${a.astrologerId}`, {
      state: { astrologerName: a.name, astrologerImage: a.image },
    });
  };

  if (loading || astrologers.length === 0) return null;

  // Duplicate cards for seamless infinite loop
  const looped = [...astrologers, ...astrologers, ...astrologers];

  return (
    <div className="asl-wrap">
      {/* Header */}
      <div className="asl-header">
        <div className="asl-header-left">
          <span className="asl-live-pill">
            <span className="asl-pulse-dot"></span> LIVE NOW
          </span>
          <h2 className="asl-title">
            Talk to <span className="asl-accent">Expert Astrologers</span>
          </h2>
        </div>
        <button className="asl-viewall" onClick={() => navigate("/chat-with-astrologer")}>
          View All →
        </button>
      </div>

      {/* Infinite marquee track */}
      <div className="asl-marquee-outer">
        <div
          className="asl-marquee-track"
          style={{ "--count": looped.length }}
        >
          {looped.map((a, i) => (
            <div className="asl-card" key={`${a.astrologerId}-${i}`}>
              {/* Top accent bar */}
              <div className="asl-card-bar"></div>

              {/* Online badge */}
              <span className={`asl-badge ${a.chatStatus === 2 ? "asl-badge-on" : "asl-badge-off"}`}>
                {a.chatStatus === 2 ? "● Online" : "● Offline"}
              </span>

              {/* Avatar */}
              <div className="asl-avatar-ring">
                <img
                  src={a.image}
                  alt={a.name}
                  className="asl-avatar"
                  onError={(e) => (e.currentTarget.src = defaultProfileImage)}
                />
              </div>

              <p className="asl-name">{a.name}</p>
              <p className="asl-details">{a.details}</p>
              <p className="asl-rate">₹{a.rate}<span className="asl-permin">/min</span></p>

              <div className="asl-btns">
                <button
                  className="asl-btn-chat"
                  onClick={() => handleChat(a)}
                >
                  💬 Chat
                </button>
                <button
                  className="asl-btn-call"
                  onClick={() => navigate("/call-with-astrologer")}
                >
                  📞 Call
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AstrologerSlider;